/* Service cards own only disclosure state. Navigation always uses native links.
 * Custom-element lifecycle supports editor/Section Rendering replacements.
 */
if (!customElements.get('service-cards')) {
  customElements.define('service-cards', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-service-card-toggle]');
        if (!toggle || toggle.closest('service-cards') !== this) return;
        const card = toggle.closest('[data-service-card]');
        this.setExpanded(card, toggle.getAttribute('aria-expanded') !== 'true');
      }, options);

      this.addEventListener('keydown', (event) => {
        const card = event.target.closest('[data-service-card]');
        if (event.key !== 'Escape' || !card?.classList.contains('is-expanded')) return;
        this.setExpanded(card, false);
        card.querySelector('[data-service-card-toggle]')?.focus();
        event.stopPropagation();
      }, options);

      for (const type of ['shopify:block:select', 'shopify:block:deselect']) {
        this.addEventListener(type, (event) => {
          const card = event.target.closest('[data-service-card]');
          if (!card || card.closest('service-cards') !== this) return;
          this.setExpanded(card, type === 'shopify:block:select');
          if (type === 'shopify:block:select') {
            card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }, options);
      }
    }

    disconnectedCallback() {
      this.events?.abort();
    }

    setExpanded(card, expanded) {
      card.classList.toggle('is-expanded', expanded);
      card.querySelector('[data-service-card-toggle]')?.setAttribute('aria-expanded', String(expanded));
    }
  });
}
